import React from "react";
import ReactDOM from 'react-dom';

function withModal(WrappedComponent: any) {

    const modalRoot = document.getElementById('modal-root')

    return class extends React.Component<any, any> {

        el = document.createElement('div')

        componentDidMount() {
            if (modalRoot)
                modalRoot.appendChild(this.el)
        }

        componentWillUnmount() {
            if (modalRoot)
                modalRoot.removeChild(this.el)
        }

        public render() {
            let transparentDiv = {
                zIndex: '1150',
                opacity: 0.6,
                'willChange': 'opacity',
                transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                position: 'fixed' as 'fixed'
            }

            return ReactDOM.createPortal(
            <>
                <div aria-hidden="true" style={transparentDiv}></div>
                <WrappedComponent {...this.props} />
            </>, this.el)
        }
    }
}

export default withModal